<template>
	<div style="height: calc(100% - 64px);">
		<div class="media-add-ep-list" ref="epList" >
			<div :class="fromIsOpen ? 'from-close top-search' : 'top-search' " ref="searchForm" >
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="投放链接ID" prop="tfid">
						<el-input v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable
							@keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="用户ID" prop="userId">
						<el-input v-model="formInline.userId" placeholder="请输入用户ID" clearable
							@keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="广告计划ID" prop="promotionid">
						<el-input v-model="formInline.promotionid" placeholder="请输入广告计划ID" clearable
							@keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="回传状态" prop="statusB">
						<!-- <el-select v-model="statusBList" multiple placeholder="请选择回传状态" clearable @change="search"
							style="width: 180px;">
							<el-option v-for="item in statusBOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select> -->
						<el-select v-model="formInline.status" placeholder="请选择回传状态" clearable @change="search"
							style="width: 180px;">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否漏回传" prop="status">
						<el-select v-model="formInline.statusB" placeholder="请选择是否漏回传" clearable @change="search"
							style="width: 200px;">
							<el-option v-for="item in statusBOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="短剧名" prop="tfid">
						<el-input v-model="formInline.svName" placeholder="请输入短剧名" clearable
							@keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="订单创建时间：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" :style="{ height: tableHeight + 'px' }" >
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle"
					v-loading="loading">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column label="用户信息" width="200">
						<template slot-scope="scope" v-if="scope.row.userInfoVo">
							<div class="td-info">
								<p>用户ID：{{ scope.row.userid }}</p>
								<p>用户昵称：{{ scope.row.userInfoVo.nickName || '未绑定昵称' }}</p>
								<p>注册时间：{{ scope.row.userInfoVo.strAddTime }}</p>
								<p>用户系统类型：{{ scope.row.userInfoVo.mos }}</p>
							</div>
						</template>
						<template v-else>
							<div class="td-info">
								<p>用户ID：</p>
								<p>用户昵称：</p>
								<p>注册时间：</p>
								<p>用户系统类型：</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="小程序信息" width="200">
						<template slot-scope="scope">
							<div class="td-info" >
								<p>appid：{{ scope.row.appid }}</p>
								<p>小程序名称：{{ scope.row.appName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="推广信息">
						<template slot-scope="scope" v-if="scope.row.userInfoVo">
							<div class="td-info">
								<p><b>推广平台：</b>{{ scope.row.userInfoVo.promotionPlatform == 1 ? '抖音' : '' }}</p>
								<p><b>投放链接ID：</b>{{ scope.row.tfid }}</p>
								<p><b>clickId：</b>{{ scope.row.clickid }}</p>
								<p><b>广告计划ID：</b>{{ scope.row.promotionid }}</p>
							</div>
						</template>
						<template v-else>
							<div class="td-info">
								<p>推广平台：</p>
								<p>投放链接ID：</p>
								<p>clickId：</p>
								<p>广告计划ID：</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="充值信息">
						<template slot-scope="scope" v-if="scope.row.rechargelog">
							<div class="td-info">
								<p>充值金额：{{ scope.row.rechargelog.money}}</p>
								<p>订单ID：{{ scope.row.orderId }}</p>
								<p>充值来源：{{ scope.row.rechargelog.svName }}</p>
							</div>
						</template>
						<template v-else>
							<div class="td-info">
								<p>充值金额：</p>
								<p>订单ID：</p>
								<p>clickId：</p>
								<p>充值来源：</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="支付状态" width="120">
						<template slot-scope="scope" v-if="scope.row.rechargelog">
							<span class="danger-text" v-if="scope.row.rechargelog.status == 0">未成功</span>
							<span class="succes-text" v-if="scope.row.rechargelog.status == 1">已成功</span>
							<span class="warnning-text" v-if="scope.row.rechargelog.status == 2">未充值</span>
							<span class="danger-text" v-if="scope.row.rechargelog.status == 3">已退款</span>
						</template>
					</el-table-column>
					<el-table-column label="用户累计充值信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>累计充值次数：{{ scope.row.times }}</p>
								<p>累计充值金额：{{ scope.row.totalMoney }}</p>
								<p>累计回传次数：{{ scope.row.postTotalNumber }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="是否漏回传" width="120">
						<template slot-scope="scope">
							<span class="danger-text" v-if="scope.row.statusB == 0">不符合回传</span>
							<span class="succes-text" v-if="scope.row.statusB == 1">已回传</span>
							<span class="warnning-text" v-if="scope.row.statusB == 2">已漏不回传</span>
						</template>
					</el-table-column>
					<el-table-column label="订单创建时间" width="140">
						<template slot-scope="scope">
							<span>{{ scope.row.rechargelog?.addtime || '' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180">
						<template slot-scope="scope">
							<!-- <el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row)">详情</el-button> -->
							<div style="padding: 0 15px;">
								<span class="succes-text" v-if="scope.row.status == 1">已自动回传</span>
								<span class="danger-text" v-if="scope.row.status == 0">未回传</span>
								<span class="succes-text" v-if="scope.row.status == 2">已手动回传</span>
								<el-button type="text" v-if="scope.row.status == 0" @click="repair(scope.row.id)" style="margin-left: 25px;">补回传</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background
						:current-page="currentPage" layout="sizes, prev, pager, next, jumper, ->, total"
						:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<!-- <el-dialog title="详情" :visible.sync="dialogInfoVisible" width="1600px">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="detailformInline" size="small"
					class="demo-form-inline">
					
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="detailSearch">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="detailResetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableLinkData.result" border stripe style="width: 100%;" height="100%"
					class="tableStyle" v-loading="linkLoading">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column label="用户信息" width="200">
						<template slot-scope="scope">
							<div class="td-info" v-if="scope.row.userInfoVo">
								<p>用户ID：{{ scope.row.userid }}</p>
								<p>用户昵称：{{ scope.row.userInfoVo.nickName || '未绑定昵称' }}</p>
								<p>注册时间：{{ scope.row.userInfoVo.strAddTime }}</p>
								<p>用户系统类型：{{ scope.row.userInfoVo.mos }}</p>
							</div>
							<div class="td-info" v-else>
								<p>用户ID：{{ scope.row.userid }}</p>
								<p>用户昵称：</p>
								<p>注册时间：</p>
								<p>用户系统类型：</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="推广信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p v-if="scope.row.userInfoVo"><b>推广平台：</b>{{ scope.row.userInfoVo.promotionPlatform == 1? '抖音' : ''}}</p>
								<p v-else><b>推广平台：</b></p>
								<p><b>投放链接ID：</b>{{ scope.row.tfid }}</p>
								<p><b>clickId：</b>{{ scope.row.clickid }}</p>
								<p><b>广告计划ID：</b>{{ scope.row.promotionid }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="充值信息">
						<template slot-scope="scope">
							<div class="td-info" v-if="scope.row.rechargelog">
								<p>充值金额：{{ scope.row.rechargelog.money }}</p>
								<p>实付金额：{{ scope.row.rechargelog.money }}</p>
								<p>支付单号：{{ scope.row.orderId }}</p>
								<p>渠道订单号：{{ scope.row.rechargelog.outDitchOrderId }}</p>
								<p>商户订单号：{{ scope.row.rechargelog.merchantOrderId }}</p>
							</div>
							<div class="td-info" v-else>
								<p>充值金额：</p>
								<p>实付金额：</p>
								<p>支付单号：</p>
								<p>渠道订单号：</p>
								<p>商户订单号：</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="支付状态" width="150">
						<template slot-scope="scope">
							<div>
								<p v-if="scope.row.rechargelog.status == 0" class="danger-text">未成功</p>
								<p v-if="scope.row.rechargelog.status == 1" class="succes-text">已成功</p>
								<p v-if="scope.row.rechargelog.status == 2" class="primary-text">未充值</p>
								<p v-if="scope.row.rechargelog.status == 3" class="warnning-text">已退款</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="是否漏回传" width="150">
						<template slot-scope="scope">
							<span v-if="scope.row.statusB == 0">不符合回传</span>
							<span v-if="scope.row.statusB == 1">已回传</span>
							<span v-if="scope.row.statusB == 2">已漏不回传</span>
						</template>
					</el-table-column>
					<el-table-column label="其他信息" width="200">
						<template slot-scope="scope">
							<p>{{ scope.row.addTime }}</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<div style="padding: 0 15px;">
								<span class="succes-text" v-if="scope.row.status == 1">已自动回传</span>
								<span class="danger-text" v-if="scope.row.status == 0">未回传</span>
								<span class="succes-text" v-if="scope.row.status == 2">已手动回传</span>
								<el-button type="text" v-if="scope.row.status == 0" @click="repair(scope.row.id)"
									style="margin-left: 25px;">补回传</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChangeLink" @size-change="handleSizeChangeLink"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableLinkData.pageSize" background
						:current-page="linkCurrentPage" layout="sizes, prev, pager, next, jumper, ->, total"
						:total="tableLinkData.totalNum">
					</el-pagination>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="margin-top: 20px;">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog> -->
	</div>
</template>
<script>
import { rechargeList, addRechargeRepair, } from "@/api/dysvzk/data/return";
export default {
	name: 'RechargeReturnList',
	props:['fromIsOpen'],
	data() {
		return {
			loading: false,
			dataTime: [],
			createTime:[],
			statusBList: [],
			formInline: {
				userId: '',
				statusB: '',
				status: '',
				tfid: '',
				agentId: '',
				promotionid: '',
				startTime: '',
				endTime: '',
				appId: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
				selectType: 2,
				svName:''
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			dialogInfoVisible: false,
			rowForm: {},
			statusOptions: [
				{
					value: 1,
					label: '已回传'
				},
				{
					value: 2,
					label: '已手动回传'
				},
				{
					value: 0,
					label: '未回传'
				}
			],
			statusBOptions: [
				{
					value: 0,
					label: '不符合回传'
				},
				{
					value: 1,
					label: '已回传'
				},
				{
					value: 2,
					label: '已漏'
				},
			],
			isShowDialogAgent: false,
			tableLinkData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			linkCurrentPage: 1,
			linkLoading: false,
			linkId: '',
			tableHeight:0,//表格高度
		}
	},
	computed: {},
	watch: {
		fromIsOpen(newValue) {
			console.log("展开、收起筛选面板",newValue)
			this.$nextTick(() => {
        this.calcTableHeight(); // 表单展开/收起后重新计算表格高度
      });
		},
	},
	created() {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isShowDialogAgent = false
		} else {
			this.isShowDialogAgent = true
		}
	},
	mounted: function () {
		this.calcTableHeight(); // 初始化计算表格高度
    window.addEventListener('resize', this.calcTableHeight); // 监听窗口大小变化
		this.loading = true
		this.getTableData()
	},
	beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight); // 移除监听
  },
	methods: {
		search () {
			this.loading = true
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery: function () {
			this.loading = true
			this.$refs['formInline'].resetFields()
			this.createTime = []
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange(val) {
			this.loading = true
			this.tableData.pageSize = val
			this.currentPage = 1
			this.getTableData()
		},
		handleCurrentChange(value) {
			this.loading = true
			this.currentPage = value
			this.getTableData()
		},
		//详情搜索和重置
		detailSearch () {
			this.linkLoading = true
			this.linkCurrentPage = 1
			this.getTableLinkData(this.linkId)
		},
		detailResetQuery: function () {
			this.linkLoading = true
			this.$refs['detailformInline'].resetFields()
			this.dataTime = []
			this.getTableLinkData(this.linkId)
		},
		// 详情pageSize切换
		handleSizeChangeLink(val) {
			this.tableData.pageSize = val
			this.linkCurrentPage = 1
			this.linkLoading = true
			this.getTableLinkData(this.linkId)
		},
		handleCurrentChangeLink(value) {
			this.linkCurrentPage = value
			this.linkLoading = true
			this.getTableLinkData(this.linkId)
		},
		handleLook(row) {
			this.dialogInfoVisible = true
			this.rowForm = row
			this.linkLoading = true
			this.linkId = row.id
			this.linkCurrentPage = 1
			this.getTableLinkData(row.id)
		},
		// 列表
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			// this.formInline.statusB = this.statusBList.toString()
			this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
			this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2,type:2 };
			rechargeList(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.loading = false
					this.tableData = response.data.content
					console.log("------121", this.tableData.result)
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
			// totallist(paramJson).then(response => {
			// 	if (response.data.head.flag === 0) {
			// 		this.loading = false
			// 		this.tableData = response.data.content
			// 		console.log("------121", this.tableData.result)
			// 	} else {
			// 		this.$message.error(response.data.head.desc)
			// 	}
			// });
		},
		repair(id) {
			addRechargeRepair({
				infoId: id
			}).then(response => {
				if (response.data.head.flag === 0) {
					// this.getTableLinkData(this.linkId)
					this.$message.success('补回传成功！')
					this.getTableData()
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		tabChange(val) {
			this.tabValue = val;
		},
		// 计算表单的高度
		calcTableHeight() {
      const windowHeight = this.$refs.epList.offsetHeight; // 视口高度
      const searchFormHeight = this.$refs.searchForm.offsetHeight; // 搜索表单高度
      // 计算表格高度
      this.tableHeight = windowHeight - searchFormHeight;
    },
		// 详情列表
		// getTableLinkData(userId) {
		// 	let json2 = {
		// 		pageNo: this.linkCurrentPage,
		// 		pageSize: this.tableData.pageSize
		// 	};
		// 	this.formInline.statusB = this.statusBList.toString()
		// 	this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
		// 	this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
		// 	let json1 = this.formInline;
		// 	let paramJson = { ...json1, ...json2, userId };
		// 	rechargeList(paramJson).then(response => {
		// 		if (response.data.head.flag === 0) {
		// 			this.tableLinkData = response.data.content
		// 			this.linkLoading = false
		// 		} else {
		// 			this.$message.error(response.data.head.desc)
		// 		}
		// 	});
		// },

	}
}
</script>
<style lang="scss" scoped>
.media-add-ep-list {
	width: 100%;
	height: calc(100% - 64px);
	position: relative;
	color: #409eff;
	font-size: 14px;
	display: flex;
  flex-direction: column;
	.caretbtn {
		position: absolute;
		right: 30px;
		top: 0;
		margin-left: 20px;
	}
	.top-search {
    flex-shrink: 0; /* 防止表单区域被压缩 */
    overflow: hidden;
    transition: height 0.3s;
  }
	.from-close {
		height: 0;
		overflow: hidden;
	}
	.tableTh {
    flex: 1; /* 表格区域自动填充剩余空间 */
    position: relative;
  }
}
</style>
